import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './yearsection.css';

const YearSection = () => {
  return (
    <div className="year-section">
      <Container>
        <Row className="justify-content-center align-items-center ">
          <Col xs={6} md={3}>
            <div className="year-item text-center">
              <h2>10+ </h2>
              <p>Years of experience</p>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="year-item text-center">
              <h2>130+</h2>
              <p>Trusted Companies</p>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="year-item text-center">
              <h2>5000+</h2>
              <p>Verified Leaders</p>
            </div>
          </Col>
          <Col xs={6} md={3}>
            <div className="year-item text-center">
              <h2>15%</h2>
              <p>More Closures</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default YearSection;